// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2Dekc","label":"Completed_label__lJNuY"};